/** Provider onboarding lesson — GLP-1 program overview. */
export const GLP1_PROGRAM_OVERVIEW_URL =
  'https://community.berrystreet.co/c/dupe-2_new-provider-onboarding/sections/346552/lessons/2783452';

export const GLP1_PATIENT_ONE_PAGER_URL =
  'https://www.berrystreet.co/glp-1-faq';

/** `eligible` (1b): no stated interest. `interested` (1a): asked about GLP-1 when booking. */
export type Glp1OfferVariant = 'eligible' | 'interested';

/** Headlines follow the patient's first name; a missing description keeps the offer's own. */
export const GLP1_OFFER_COPY: Record<
  Glp1OfferVariant | 'sent',
  { headline: string; description?: string }
> = {
  eligible: { headline: 'is eligible for GLP-1 support' },
  interested: {
    headline: 'asked about GLP-1 support when booking',
    description:
      'Send the link below so they can meet with a Berry Street prescriber. GLP-1 care happens alongside your nutrition visits, all on Berry Street.',
  },
  sent: {
    headline: 'has their GLP-1 link',
    description:
      'They can now start the intake and meet with a Berry Street prescriber. You stay their dietitian throughout.',
  },
};

export const GLP1_PROGRAM_RESOURCE_LINKS: ReadonlyArray<{
  href: string;
  label: string;
}> = [
  {
    href: GLP1_PROGRAM_OVERVIEW_URL,
    label: 'Program overview',
  },
  {
    href: GLP1_PATIENT_ONE_PAGER_URL,
    label: 'Patient one-pager',
  },
];
